// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceRange_container__Qaa23","dash":"PriceRange_dash__okbow","priceContainer":"PriceRange_priceContainer__oAiQS","error":"PriceRange_error__w8Tza"};